import React, { useState, useEffect } from "react";
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import Helper from 'src/helper/Helper';
import { useObjCommonFilterStore } from "../../../hooks/objCommonFilter";
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';


export function SearchUser() {
    const [__check] = useAxiosIndicatorCheck();
    const defaultModel = { firstName: "", lastName: "", email: "" };
    const [searchData, setSearchData] = useState(defaultModel);
    const [{ filter_list }, { }, { set_filter_list }] = useObjCommonFilterStore();
    const [{ }, { system_alert_indicator, clear_all_system_alert }, { }] = useDOMAttachToSystemStore();

    const keyMap = {
        email: "Email",
        lastName: "Last Name",
        firstName: "First Name",
    }

    useEffect(() => {
        if (!filter_list || Object.entries(filter_list).length === 0) {
            setSearchData(defaultModel)
        } else {
            const searchingData = defaultModel;
            searchingData.email = filter_list?.email?.searchKeyword.trim()? filter_list?.email?.searchKeyword.trim() : '';
            searchingData.firstName = filter_list?.firstName?.searchKeyword.trim() ? filter_list?.firstName?.searchKeyword.trim() : '';
            searchingData.lastName = filter_list?.lastName?.searchKeyword.trim() ? filter_list?.lastName?.searchKeyword.trim() : '';
            setSearchData(searchingData)
        }
    }, [filter_list]);

    const onSearch = (e) => {
        e.preventDefault();

        const isSearchDataEmpty = Object.values(searchData).every(value => !value);


        if (isSearchDataEmpty) {

            system_alert_indicator({
                name: "adminconsole",
                message: "At least one of the fields (First Name, Last Name, or Email) should have search keywords to display results",
                type: "danger",
                isDisplayIcon: true,
                isDisplay: false
            })
            return;
        }
        const isSearchDataMinimum2 = Object.values(searchData).every(value => value.length < 2);
        if (isSearchDataMinimum2) {
            system_alert_indicator({
                name: "adminconsole",
                message: 'Minimum 2 characters required for search',
                type: "danger",
                isDisplayIcon: true,
                isDisplay: false
            })
            return;
        }


        const filterList = Object.entries(searchData)
            .filter(([key, value]) => Helper.valueIsNotNull(value)).map((v) => {
                return {
                    searchType: keyMap[v[0]],
                    key: v[0],
                    [Array.isArray(v[1]) ? 'searchKeywordArr' : 'searchKeyword']: v[1].trim(),
                };
            });

        const filterListObject = filterList?.reduce((acc, curr) => {
            acc[curr.key] = curr;
            return acc;
        }, {});


        // Clear Alert
        clear_all_system_alert({})
        set_filter_list(filterListObject);
    };

    const onValueChange = (field, value) => {
        setSearchData({ ...searchData, [field]: value });
    }

    return (
        <>
            <div className='bg-grey2'>
                <div className='container'>
                    <div className="accordion-item ">
                        <h2 className="accordion-header" id="searchInput">
                            <button className="accordion-button" type="button" data-toggle="collapse"
                                data-target="#collapseSearch" aria-expanded="true" aria-controls="collapseOne">
                                <b className="font-16">Search</b>
                            </button>
                        </h2>

                        <div id="collapseSearch" className="accordion-collapse collapse in" aria-labelledby="searchInput"
                            data-parent="#accordionExample">
                            <div className="accordion-body p-0">

                                <form onSubmit={(e) => { onSearch(e) }} >
                                    <div className="row bs5 m-t-30 ms-0 me-0 usersearch-container">
                                        <div className="col-sm-12 col-md-4 mb-2">
                                            <label htmlFor="firstName">First Name </label>
                                            <input className="ps-2 form-control form-control-sm mb-0" placeholder="First Name" type="text"
                                                value={searchData.firstName}
                                                onChange={({ target: { value } }) => onValueChange('firstName', value)}
                                                maxLength={50}
                                            />
                                        </div>


                                        <div className="col-sm-12 col-md-4 mb-2">
                                            <label htmlFor="lastName">Last Name </label>
                                            <input className="ps-2 form-control form-control-sm mb-0" placeholder="Last Name" type="text"
                                                value={searchData.lastName}
                                                onChange={({ target: { value } }) => onValueChange('lastName', value)} maxLength={50}
                                            />
                                        </div>

                                        <div className="col-sm-12 col-md-4 mb-2">
                                            <label htmlFor="email">Email </label>
                                            <input className="ps-2 form-control form-control-sm mb-0" placeholder="Email" type="text"
                                                value={searchData.email}
                                                onChange={({ target: { value } }) => onValueChange('email', value)}
                                            />
                                        </div>
                                    </div>

                                    <div className="row bs5 m-t-20">
                                        <div className="col-sm-12 text-sm-end">
                                            <button className="btn btn-secondary bs5"
                                            // onClick={() => set_find_bom_input_bom_listing(search)}
                                            >Search
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>

    );

}
